export const originalOrUnit = (originalInCents: number, unitInCents: number): number =>
  originalInCents > 0 ? originalInCents : unitInCents;

export const subtotalOrDiscountedFallback = (
  subtotalInCents: number,
  unitOriginalInCents: number,
  quantity: number,
  discountPercent: number,
): number => {
  if (subtotalInCents > 0 || unitOriginalInCents <= 0) return subtotalInCents;
  return Math.round(unitOriginalInCents * quantity * ((100 - discountPercent) / 100));
};
